/* eslint-disable */
export default {
  callerCall: '來電者',
  transferCall: '轉接',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
